import { Button, Modal, Row, Tooltip, Typography } from 'antd';
import PropTypes from 'prop-types';
import { EyeOutlined } from '@ant-design/icons';
import { useDictionaryTranslation } from '../../../hooks/useDictionaryTranslation';

export const ErrorsModal = ({ errors = [], show, onClose }) => {
  const { translate: t } = useDictionaryTranslation();

  const getPageHandler = (pageIndex) => () => {
    onClose({ pageIndex });
  };

  return (
    <Modal
      title={t('someFieldsHaveErrors')}
      open={show}
      onCancel={onClose}
      footer={
        <Row justify="end">
          <Button type="primary" onClick={onClose}>
            {t('accept')}
          </Button>
        </Row>
      }
    >
      <Typography.Paragraph>
        <ul>
          {errors?.map((page, index) => {
            if (!page.errors?.length) return null;
            return (
              <li key={page.id}>
                <Typography.Text strong>
                  {page.title}
                  <Tooltip title={t('view')}>
                    <Button onClick={getPageHandler(index)} icon={<EyeOutlined />} type="link" />
                  </Tooltip>
                </Typography.Text>
                <ul>
                  {page.errors.map((field) => {
                    return (
                      <li key={field.idInput}>
                        <Typography.Text>{field.label}</Typography.Text>
                        <br />
                        <Typography.Text type="danger">{t(field.error?.message)}</Typography.Text>
                      </li>
                    );
                  })}
                </ul>
              </li>
            );
          })}
        </ul>
      </Typography.Paragraph>
    </Modal>
  );
};

ErrorsModal.propTypes = {
  errors: PropTypes.array,
  onClose: PropTypes.func,
  show: PropTypes.bool,
};
